import api from '@/api';

/**
 * Get a list of all property file types
 */
class PropertyFileType {
  /**
   * Get a list of all property file types
   */
  static list() {
    return api.get('/properties/files/types');
  }
}

export default PropertyFileType;
